import { render, staticRenderFns } from "./ReportMealsTabDishes.vue?vue&type=template&id=0956d142&scoped=true"
import script from "./ReportMealsTabDishes.vue?vue&type=script&lang=js"
export * from "./ReportMealsTabDishes.vue?vue&type=script&lang=js"
import style0 from "./ReportMealsTabDishes.vue?vue&type=style&index=0&id=0956d142&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0956d142",
  null
  
)

export default component.exports